import moment from 'moment'
import { getUIFormatDate } from '../../../../../lib/MomentHelper'
import { EMPTY_VALUE } from '../../../../../constants/globalTypes'

const SummaryDate = props => {
  const { date } = props
  const formatedDate = date
    ? getUIFormatDate(moment(date))
    : EMPTY_VALUE
  return (
    <p>
      {`統計區間：累計至 ${formatedDate}`}
    </p>
  )
}

export default SummaryDate
